import styled from 'styled-components';

const FlexContainer = styled.div`
    display: flex;
    justify-content: ${props => props.justifyContent ? props.justifyContent : 'flex-start'};
    align-items:  ${props => props.alignItems ? props.alignItems : 'flex-start'};
    flex-direction: ${props => props.direction ? props.direction : 'row'};
    flex-wrap: ${props => props.wrap === 'nowrap' ? 'nowrap' : 'wrap'};
    margin: ${props => props.mg && props.mg};
    padding: ${props => props.pd && props.pd};
    width: ${props => props.fullWidth && '100%'};
    flex-grow: ${props => props.flexGrow};
`;

export default FlexContainer;